import { Command, HttpMethod } from "~/extensions/api";
export class ChangeMailAddress extends Command {
    constructor(command) {
        super(HttpMethod.Post, "keiyaku/mail/change");
        this.mailAddress = command.mailAddress;
    }
    mailAddress = "";
}
